module.exports = __webpack_public_path__ + "img/layout-11_3.a98dd150.png";